import { parseDate } from '@/utils/date'
import cn from 'clsx'

import { TextInput } from '@components/shared/TextInput'
import TextArea from '@components/shared/TextArea'
import Flatpickr from 'react-flatpickr'
import { useRef } from 'react'

const MetaRow = ({
    errors,
    values,
    onChange,
    instrumentDate,
    setInstrumentDate,
    fileDate,
    setFileDate,
    legalDescriptions,
    showLegal,
}) => {
    
    const instDateRef = useRef(null)
    const fileDateRef = useRef(null)
    
    return (
        
        <div className="grid grid-cols-2 gap-4">
            
            <div>
                <div className="mt-3 grid grid-cols-3 gap-4">
                    <TextInput
                        name="bookType"
                        className=""
                        inputClassName="input input-sm w-full input-bordered"
                        value={values?.bookType ?? ''}
                        handleChange={onChange}
                        label="Book Type"/>
                    <TextInput
                        name="bookVolume"
                        className=""
                        inputClassName={cn('input input-sm w-full input-bordered',
                            { 'border-danger': errors?.bookVolume })}
                        value={values?.bookVolume ?? ''}
                        handleChange={onChange}
                        label="Book/Volume"/>
                    <TextInput
                        name="bookPage"
                        className=""
                        inputClassName={cn('input input-sm w-full input-bordered',
                            { 'border-danger': errors?.bookPage })}
                        value={values?.bookPage ?? ''}
                        handleChange={onChange}
                        label="Page"/>
                </div>
                <div className="mt-3 grid grid-cols-2 gap-4">
                    <TextInput
                        name="instrumentNumber"
                        inputClassName="input input-sm w-full input-bordered"
                        value={values?.instrumentNumber ?? ''}
                        handleChange={onChange}
                        label="Instrument #"/>
                    <TextInput
                        name="instrumentType"
                        className="col-md-6"
                        inputClassName={cn('input input-bordered input-sm w-full',
                            { 'border-danger': errors?.instrumentType })}
                        value={values?.instrumentType ?? ''}
                        handleChange={onChange}
                        label="Instrument Type"/>
                </div>
                <div className="mt-3 grid grid-cols-2 gap-4">
                    <div className="">
                        <label data-toggle="tooltip" data-placement="top" title="Instrument Date">
                            Instrument Date
                        </label>
                        <Flatpickr
                            ref={instDateRef}
                            className="w-full input input-bordered flatpickr-input"
                            value={instrumentDate}
                            name="instrumentDate"
                            options={{
                                dateFormat: 'M-d-Y',
                                allowInput: true,
                                parseDate: date => parseDate(date, null, false),
                            }}
                            onBlur={ev => {
                                // necessary to force the changes when user types the date.
                                // somehow flatpickr doesn't trigger onchange in this scenario
                                if (!instDateRef.current.flatpickr.innerContainer.parentElement
                                    .contains(ev.relatedTarget))
                                    setInstrumentDate(instDateRef.current.flatpickr.selectedDates[0])
                            }}
                            onChange={date => setInstrumentDate(date[0])} />
                    </div>
                    <div className="">
                        <label data-toggle="tooltip" data-placement="top" title="File Date">
                            File Date
                        </label>
                        <Flatpickr
                            ref={fileDateRef}
                            className="w-full input input-bordered flatpickr-input"
                            value={fileDate}
                            name="fileDate"
                            options={{
                                dateFormat: 'M-d-Y',
                                allowInput: true,
                                parseDate: date => parseDate(date, null, false),
                            }}
                            onBlur={ev => {
                                // necessary to force the changes when user types the date.
                                // somehow flatpickr doesn't trigger onchange in this scenario
                                if (!fileDateRef.current.flatpickr.innerContainer.parentElement
                                    .contains(ev.relatedTarget))
                                    setFileDate(fileDateRef.current.flatpickr.selectedDates[0])
                            }}
                            onChange={date => setFileDate(date[0])} />
                    </div>
                </div>
                <div className="mt-3">
                    <TextInput
                        data-tooltip-id="default-tip"
                        data-tooltip-content="How the Grantor(s) should appear on a runsheet."
                        name="fullGrantor"
                        inputClassName="w-full input input-bordered"
                        value={values?.fullGrantor ?? ''}
                        handleChange={onChange}
                        label="Full Grantor" />
                </div>
                <div className="mt-3">
                    <TextInput
                        data-tooltip-id="default-tip"
                        data-tooltip-content="How the Grantee(s) should appear on a runsheet."
                        name="fullGrantee"
                        inputClassName="w-full input input-bordered"
                        value={values?.fullGrantee ?? ''}
                        handleChange={onChange}
                        label="Full Grantee" />
                </div>
            </div>
            
            <div>
                <div className="mt-3 flex flex-col">
                    <label>Legal Description</label>
                    <div className="h-[89px] input input-bordered overflow-auto whitespace-pre-line cursor-pointer"
                        onClick={showLegal}>
                        {legalDescriptions
                            ?.filter(ld => ld.visible)
                            ?.map(ld => 
                                <div key={ld.id} className="pt-2">
                                    {ld.summary}
                                </div>)
                        }
                    </div>
                </div>
                <div className="mt-3">
                    <label>Comments</label>
                    <TextArea
                        className="textarea textarea-bordered w-full h-[89px]"
                        name="comments"
                        value={values?.comments ?? ''}
                        onChange={onChange} />
                </div>
                <div className="mt-3">
                    <label>Notes</label>
                    <TextArea
                        className="textarea textarea-bordered w-full h-[89px]"
                        name="notes"
                        value={values?.notes ?? ''}
                        onChange={onChange} />
                </div>
            </div>
        
        </div>
        
    )
    
}

export default MetaRow
